import axios from 'axios';

const API_URL =
  'https://prod-253.westeurope.logic.azure.com/workflows/adf99d08434a42cd8a9fcb18fda968fd/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=cNEHfS6BNB5fwhLP_lxpDkQQpEWdruU18Z__R_W3VSg';

export function getManagers() {
  return axios.get(API_URL);
}
